import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Button } from "sr/helpers";

export const IndividualCleanerList = ({allCleaner, jobDraft}) => {



  const [startTime, setStartTime] = useState<string>('')
  const [endTime, setEndTime] = useState<string>('')
  const [jobId, setJobId] = useState<string>()
  const [id, setId] = useState<string>()
  const params = useParams()

  useEffect(() => {
    const { id, jobid, from, to } = params
    setJobId(jobid)
    setStartTime(from)
    setEndTime(to)
    setId(id)
  }, [params])

  return (
<div className='col-span-3 bg-white rounded-lg'>
    <div className='border-neutral-200 border-b py-4 flex items-center'>
        <Link to={`/individual/cleaner-profiles/${startTime}/${endTime}/${jobId}`} state={jobId === 'draft' && jobDraft ? {jobDraft} : undefined}>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
  <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
</svg>
  </Link>
   <div>
    <h2 className='px-4 text-2xl  text-[#595959]'>All Cleaner</h2>
    <p className='px-4 text-xs text-[#595959]'>{(allCleaner?.findIndex((item)=> item?.id===id)+1)} of {allCleaner?.length} Cleaner</p>
   </div>
    </div>
   { allCleaner?.map((data)=> (
    <Link to={`/individual/cleaner-profile-details/${data?.id}/${jobId}/${startTime}/${endTime}`} state={jobId === 'draft' && jobDraft ? {jobDraft} : undefined}>
    <div className={`border-neutral-200 hover:bg-neutral-200 border-b py-4 ${data?.id===id ? 'bg-[#FAF9F8]':'bg-white'}`}>
    <h2 className='px-4 text-base '>{data?.first_name} {data?.last_name} </h2>
    <p className='px-4 text-xs text-[#595959]'>{data?.address?.state ? data?.address?.city + ', ' + data?.address?.state : data?.address?.city}</p>
    </div>
    </Link>
))}
    </div>  
);
};
